/* HeyBear · Footer: giveaway sign-up validation (Shopify customer form) + fit the big wordmark to the width. */
HB.section('footer', function (root) {
  var off = [];
  var on = function (el, ev, fn, o) { el.addEventListener(ev, fn, o); off.push(function () { el.removeEventListener(ev, fn, o); }); };
  HB.reveal(root);

  /* Home always means the absolute top, never a browser-restored homepage
     position or a section hash left over from earlier navigation. */
  var homeLink = root.querySelector('[data-footer-home]');
  if (homeLink) on(homeLink, 'click', function (event) {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var rootPath;
    try { rootPath = new URL(HB.routes.root || '/', location.origin).pathname; } catch (_) { rootPath = '/'; }
    try {
      sessionStorage.setItem('hb:home-force-top', '1');
      sessionStorage.removeItem('hb:home-history-restore');
      sessionStorage.removeItem('hb:home-history-curtain');
      sessionStorage.removeItem('hb:home-history-active');
    } catch (_) {}
    if (location.pathname !== rootPath) return;
    event.preventDefault();
    if (window.HB_GO_HOME_TOP) window.HB_GO_HOME_TOP();
    else {
      if (location.hash) history.replaceState(null, '', location.pathname + location.search);
      if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
      window.scrollTo(0, 0);
    }
    if (window.ScrollTrigger) ScrollTrigger.update();
    try { sessionStorage.removeItem('hb:home-force-top'); } catch (_) {}
  });

  /* Footer dropdowns: hover intent on pointer devices, focus/click for keyboard
     and touch. Native details remains the no-JavaScript fallback. */
  (function () {
    var dropdowns = [].slice.call(root.querySelectorAll('.ft details.dd'));
    var finePointer = matchMedia('(hover:hover) and (pointer:fine)');
    var mobileLayout = matchMedia('(max-width:900px)');
    var keyboardMode = false;
    var lastPointerType = '';
    var timers = new Map();
    var setOpen = function (details, open) {
      details.open = open;
      var summary = details.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', open ? 'true' : 'false');
    };
    var closeAll = function (except) {
      dropdowns.forEach(function (details) {
        clearTimeout(timers.get(details));
        if (details !== except) setOpen(details, false);
      });
    };
    var usesHover = function () {
      return finePointer.matches && !mobileLayout.matches;
    };
    on(root, 'keydown', function (event) {
      if (event.key === 'Tab' || event.key.indexOf('Arrow') === 0) keyboardMode = true;
    });
    on(root, 'pointerdown', function (event) {
      keyboardMode = false;
      lastPointerType = event.pointerType || '';
    });
    dropdowns.forEach(function (details) {
      var summary = details.querySelector('summary');
      setOpen(details, details.open);
      var open = function () {
        clearTimeout(timers.get(details));
        closeAll(details);
        setOpen(details, true);
      };
      var close = function (now) {
        clearTimeout(timers.get(details));
        timers.set(details, setTimeout(function () {
          if (keyboardMode && details.contains(document.activeElement)) return;
          setOpen(details, false);
        }, now ? 0 : 160));
      };
      on(summary, 'pointerenter', function (event) {
        if (usesHover() && event.pointerType !== 'touch') open();
      });
      on(details, 'pointerenter', function (event) {
        if (usesHover() && event.pointerType !== 'touch') clearTimeout(timers.get(details));
      });
      on(details, 'pointerleave', function (event) {
        if (usesHover() && event.pointerType !== 'touch') close(false);
      });
      on(summary, 'click', function (event) {
        event.preventDefault();
        if (usesHover() && lastPointerType !== 'touch' && !keyboardMode) {
          open();
          return;
        }
        var shouldOpen = !details.open;
        closeAll(details);
        setOpen(details, shouldOpen);
      });
      on(details, 'focusin', function () { if (keyboardMode) open(); });
      on(details, 'focusout', function (event) {
        if (!details.contains(event.relatedTarget)) close(true);
      });
      on(details, 'keydown', function (event) {
        if (event.key === 'Escape') {
          setOpen(details, false);
          summary && summary.focus();
        }
      });
      [].forEach.call(details.querySelectorAll('a'), function (link) {
        on(link, 'click', function () { closeAll(); });
      });
      off.push(function () { clearTimeout(timers.get(details)); });
    });
    [].forEach.call(root.querySelectorAll('.ft-nav > a'), function (link) {
      on(link, 'pointerenter', function () { if (usesHover()) closeAll(); });
    });
    on(document, 'pointerdown', function (event) {
      if (usesHover() && event.pointerType !== 'touch') return;
      var insideDropdown = dropdowns.some(function (details) {
        return details.contains(event.target);
      });
      if (!insideDropdown) closeAll();
    });
    on(mobileLayout, 'change', function () { closeAll(); });
  })();

  /* Build the Shop dropdown from the canonical Shopify product/variant data so
     newly configured flavours and current prices stay in sync automatically. */
  var shopMenu = root.querySelector('[data-footer-shop-menu]');
  if (shopMenu) {
    var data = HB.data();
    var flavours = (data.flavours || []).filter(function (flavour) { return flavour && flavour.name; });
    var mix = data.mix || {};
    var packUnits = function (variant) {
      if (variant.units > 1) return variant.units;
      if (/big/i.test(variant.title)) return 12;
      if (/cub/i.test(variant.title)) return 4;
      return 0;
    };
    var make = function (tag, cls, text) {
      var element = document.createElement(tag);
      if (cls) element.className = cls;
      if (text != null) element.textContent = text;
      return element;
    };
    var rootUrl = (HB.routes.root || '/').replace(/\/?$/, '/');
    var productUrl = function (handle) { return rootUrl + 'products/' + handle; };
    var flavourHandles = {
      cola: '3-x-cola-102g',
      apple: '3-x-sour-apple-102g',
      grape: '3-x-grape-102g',
      strawberry: '3-x-strawberry-102g',
      watermelon: '3-x-watermelon-102g'
    };
    var href = function (url, id) {
      var base = url || productUrl('heybear-protein-gummy-bears');
      return id ? base + (base.indexOf('?') > -1 ? '&' : '?') + 'variant=' + id : base;
    };
    var fan = function () {
      var holder = make('span', 'ft-shop-fan');
      flavours.filter(function (flavour) { return flavour.mix !== false; }).slice(0, 4).forEach(function (flavour) {
        var image = make('img'); image.src = flavour.pack; image.alt = ''; image.loading = 'lazy'; holder.appendChild(image);
      });
      return holder;
    };
    var renderShopMenu = function () {
      flavours = (data.flavours || []).filter(function (flavour) { return flavour && flavour.name; });
      mix = data.mix || {};
      var variants = (mix.variants || []).slice().sort(function (a, b) { return packUnits(b) - packUnits(a); });
      var grid = make('div', 'ft-shop-grid');
      var mixedGroup = make('section', 'ft-shop-group');
      mixedGroup.appendChild(make('span', 'ft-shop-kicker', 'Mixed packs'));
      var mixes = make('div', 'ft-shop-mixes');
      variants.forEach(function (variant) {
        var ready = variant && variant.id && variant.available === true && variant.price != null;
        var link = make('a', 'ft-shop-mix' + (ready ? '' : ' is-sold-out')); link.href = href(mix.url, variant.id);
        link.appendChild(fan());
        var copy = make('span', 'ft-shop-copy');
        copy.appendChild(make('b', '', variant.title));
        var units = packUnits(variant);
        copy.appendChild(make('small', '', units ? units + ' × 102g mixed bags' : 'Mixed flavour pack'));
        copy.appendChild(make('em', '', ready ? HB.money(variant.price) : 'Sold out'));
        link.appendChild(copy); mixes.appendChild(link);
      });
      if (!variants.length) mixes.appendChild(make('p', 'ft-shop-empty', 'Mixed packs coming soon.'));
      mixedGroup.appendChild(mixes); grid.appendChild(mixedGroup);

      var flavourGroup = make('section', 'ft-shop-group');
      flavourGroup.appendChild(make('span', 'ft-shop-kicker', 'Single flavours · 3-packs'));
      var flavourGrid = make('div', 'ft-shop-flavours');
      flavours.forEach(function (flavour) {
        var ready = (flavour.variants || []).some(function (variant) { return variant && variant.id && variant.available === true && variant.price != null; });
        var fallbackHandle = flavourHandles[flavour.key] || flavour.handle;
        var link = make('a', 'ft-shop-flavour' + (ready ? '' : ' is-sold-out')); link.href = flavour.url || productUrl(fallbackHandle);
        var image = make('img'); image.src = flavour.pack; image.alt = ''; image.loading = 'lazy'; link.appendChild(image);
        var copy = make('span', 'ft-shop-copy'); copy.appendChild(make('b', '', flavour.name));
        copy.appendChild(make('small', '', ready ? 'Choose your pack' : 'Sold out · get notified'));
        link.appendChild(copy); flavourGrid.appendChild(link);
      });
      if (!flavours.length) flavourGrid.appendChild(make('p', 'ft-shop-empty', 'Flavours coming soon.'));
      flavourGroup.appendChild(flavourGrid); grid.appendChild(flavourGroup);
      shopMenu.replaceChildren(grid);
    };
    renderShopMenu();
    on(document, 'hb:catalog:updated', renderShopMenu);
  }

  /* sign-up: validate, then let Shopify's customer form submit */
  var form = root.querySelector('#signup'), msg = root.querySelector('#signupMsg');
  if (form) {
    form.noValidate = true;
    on(form, 'submit', function (e) {
      var v = (form.querySelector('#email').value || '').trim();
      if (!HB.emailOk(v)) { e.preventDefault(); msg.textContent = msg.getAttribute('data-bad'); return; }
      var n = (form.querySelector('#fname').value || '').trim();
      try { sessionStorage.setItem('hb-signup-name', n); } catch (_) {}
    });
    /* after Shopify reloads with ?customer_posted=true, personalise the message */
    if (/customer_posted=true/.test(location.search)) {
      var name = ''; try { name = sessionStorage.getItem('hb-signup-name') || ''; } catch (_) {}
      msg.textContent = (msg.getAttribute('data-ok') || '').replace('[name]', name ? ', ' + name : '');
      document.getElementById('society') && document.getElementById('society').scrollIntoView();
    }
  }

  /* big HeyBear wordmark: scale the font so it fills the footer width */
  var p = root.querySelector('#ftWord');
  function fit() {
    if (!p) return;
    var box = p.parentElement, cs = getComputedStyle(box), w = box.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
    p.style.fontSize = '100px';
    var r = document.createRange(); r.selectNodeContents(p);
    var nw = r.getBoundingClientRect().width;
    if (nw > 0) p.style.fontSize = (100 * w / nw) + 'px';
  }
  fit(); on(window, 'resize', fit); document.fonts && document.fonts.ready.then(fit);

  return function () { off.forEach(function (f) { f(); }); };
});
